<div class="frame-in">
    <div class="items" [ngStyle]="itemsStyle" [ngClass]="{'hidden': loading}">
        <div class="country china"></div>

        <div
            class="country philippines zone2"
            [ngClass]="{'hover': zones[1].hover}">
        </div>

        <div
            class="poi"
            (mouseenter)="mouseEnter(1)"
            (mouseleave)="mouseLeave(1)"
            style="bottom: 172px; right: 492px;"
             [ngClass]="{
                'hover': zones[1].hover,
                'lock': zones[1].locked,
                'active': zones[1].active
                }"
             (click)="poiClick(zones[1])">
            <span *ngIf="!zones[1].locked">6</span>
        </div>
        <div
            class="country thailand zone2"
            [ngClass]="{'hover': zones[0].hover}">
        </div>
        <div class="poi"
             (mouseenter)="mouseEnter(0)"
             (mouseleave)="mouseLeave(0)"
             style="bottom: 150px; left: 192px;"
             [ngClass]="{
                'hover': zones[0].hover,
                'lock': zones[0].locked,
                'active': zones[0].active
              }"
             (click)="poiClick(zones[0])"
        >
            <span *ngIf="!zones[0].locked">5</span>
        </div>
        <div
            class="country japan"
            [ngClass]="{'hover': zones[2].hover}">
        </div>
        <div class="poi" (mouseenter)="mouseEnter(2)" (mouseleave)="mouseLeave(2)" style="bottom: 338px; right: 448px;"
             [ngClass]="{
                'hover': zones[2].hover,
                'lock': zones[2].locked,
                'active': zones[2].active
             }"
             (click)="poiClick(zones[2])"><span *ngIf="!zones[2].locked">7</span></div>
        <div
            class="country south-korea"
            [ngClass]="{
                'hover': zones[3].hover
            }"
        >
        </div>
        <div class="poi"
             (mouseenter)="mouseEnter(3)"
             (mouseleave)="mouseLeave(3)"
             style="bottom: 322px; right: 585px;"
             [ngClass]="{
                'hover': zones[3].hover,
                'lock': zones[3].locked,
                'active': zones[3].active && quizLevel !== 2
             }"
             (click)="poiClick(zones[3])">
            <span *ngIf="!zones[3].locked">8</span>
        </div>
        <div class="country malaysia dark"></div>
        <div class="poi dark" style="bottom: 26px; left: 198px;"><span>4</span></div>
        <div class="country indonesia dark"></div>
        <div class="quiz-activity zone-2-2" *ngIf="quizLevel < 2"></div>
        <div class="quiz-activity zone-2-2 active" [ngClass]="{'current': quizLevel === 2 && tick2Quiz}" [routerLink]="['/game/quiz-activity/1-2']" *ngIf="quizLevel >= 2"></div>
        <div class="quiz-activity block zone-2-1"></div>
        <svg class="road zone2">
            <g>
                <path d="M263.46,623a52.76,52.76,0,0,1,5.86-13.73c2.27-3.72,3.22-4.19,7-9.95s5.79-8.83,6.44-12.3c.86-4.58-.19-8.27-1.17-11.7-1.66-5.81-4.34-9.71-8.2-15.22-3-4.33-3.28-4-8.78-11.12-7.08-9.2-6.55-9.64-9.36-12.3a36.63,36.63,0,0,0-16.39-8.78c-7.37-1.68-13.2-.41-20.49,1.17a54,54,0,0,0-15.22,5.27c-6.8,3.69-6.25,5.56-13.46,9.95a52.24,52.24,0,0,1-18.15,7,38.29,38.29,0,0,1-14.63,0c-6.79-1.4-11.34-4.44-15.22-7-4.69-3.13-8.15-5.43-11.12-9.95a30.07,30.07,0,0,1-4.69-17c0-3.31,1-6.89,2.93-14.05,2.06-7.64,3.09-11.46,4.68-14.05,3.71-6,8.93-9,14.64-12.29a50.49,50.49,0,0,1,16.39-6.44c7.56-1.44,13.41-.54,24.58,1.17,9,1.37,9.55,2.24,17,2.92,8.08.75,12.36,1.14,17.56-.58,3.63-1.2,7.3-4.12,14.63-9.95,6.72-5.34,10.08-8,11.71-10.54,3.79-5.85,2.07-8.6,5.85-18.73A56.31,56.31,0,0,1,262.29,422c4.14-5.74,9.78-9.56,22.25-14.63A203.2,203.2,0,0,1,322,396.2a214.16,214.16,0,0,1,81.37-1.76c12.06,1.85,19.94,4,35.7,8.19a78.55,78.55,0,0,1,13.47,4.69c6.56,3,6.59,4.24,11.7,6.44a44.89,44.89,0,0,0,19.91,3.51c3.68-.23,7.53-1.32,15.22-3.51a145.18,145.18,0,0,0,14-4.69,148.48,148.48,0,0,0,14.05-6.44c7.88-4,12.43-6.31,17.56-9.95a85.68,85.68,0,0,0,18.15-17.56c2.59-3.37,3-4.39,14.63-25.75,7.79-14.26,7.9-14.33,8.79-16.39A101.36,101.36,0,0,0,594,303.71,119.81,119.81,0,0,0,594,278c-1.15-10.86-2.41-22.88-9.76-35.71-4.27-7.46-9-15.64-18.73-19.9-12.17-5.3-24.21-1-28.68.59-18.09,6.44-30.25,23.31-34.54,37.46-1.3,4.32-1.56,7.33-4.09,13.46-2.43,5.88-6.2,15-13.47,21.08-13.8,11.54-33.91,6.9-41,5.27-7.85-1.82-21.27-4.92-26.35-15.22-2.48-5.05-1-7.8-4.68-15.22-3-6.11-6.86-9.9-11.12-14a98.88,98.88,0,0,0-19.32-14.64c-15.14-8.84-20.18-8.64-35.12-15.8C326.56,215.39,329,211.6,308,201.85c-5.76-2.66-14-5.68-30.44-11.7-12.8-4.69-19.36-7.09-27.51-9.37a242.2,242.2,0,0,0-31-6.44,332.12,332.12,0,0,0-60.88-3.51C136.35,171.62,120,172.22,99,179,83.69,184,66.51,189.8,55.66,206,50.92,213,49,219.58,46.88,227c-3.64,12.64-1.84,15.36-5.27,44.49,0,0-.67,5.68-7.61,30.44-.77,2.73-2.15,7.43-6.44,10.54A16.62,16.62,0,0,1,18,315.41" transform="translate(-17.99 -170.13)" fill-opacity="null" stroke-opacity="null" stroke="#000" fill="none"/>
            </g>
        </svg>
        <!-- <div class="plane" [ngClass]="{'to-1': plane.position == 1, 'to-2': plane.position == 2, 'to-3': plane.position == 3, 'to-4': plane.position == 4}"></div> -->
        <audio id="introductionAudio" (ended)="playBgAudio()">
            <source src="assets/sounds/country.wav" type="audio/wav">
        </audio>
        <audio id="bgAudio" (ended)="playIntroductionAudio()">
            <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
        </audio>
        <img class="frame-bg" src="assets/images/zones/2/zone2-bg.jpg">
    </div>
</div>
<img class="frame-title" src="assets/images/zones/1/title.png">
<div class="footer">
    <ul class="zone-menu">
        <li>
            <a class="menu-item" [routerLink]="[ '/game/zone1' ]" routerLinkActive="active">1</a>
        </li>
        <li>
            <span class="lock" *ngIf="!haveAccess('1-2')"></span>
            <a class="menu-item" [routerLink]="[ '/game/zone2' ]" routerLinkActive="active" *ngIf="haveAccess('1-2')">2</a>
        </li>
        <li>
            <span class="lock" *ngIf="!haveAccess('1-3')"></span>
            <a class="menu-item" [routerLink]="[ '/game/zone3' ]" routerLinkActive="active" *ngIf="haveAccess('1-3')">3</a>
        </li>
        <li>
            <span class="lock" *ngIf="!haveAccess('1-4')"></span>
            <a class="menu-item" [routerLink]="[ '/game/zone4' ]" routerLinkActive="active"*ngIf="haveAccess('1-4')">4</a>
        </li>
    </ul>
    <img class="footer-bg" src="assets/images/zones/2/footer2.png">
</div>
<audio id="continentHover">
    <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
    <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
